import React, {useState} from 'react'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
}

const Accordion = ({classNames, children}: Props) => {
  const [isOpen, setIsOpen] = useState(
    mapChildrenWithFragments(children, item => item.props.isOpen)
  )

  return (
    <div className={cn('Accordion', {}, classNames)}>
      {mapChildrenWithFragments(children, (item, index) =>
        React.cloneElement(item, {
          isOpen: isOpen[index],
          onChange: (value: boolean) => {
            const nextIsOpen = []
            nextIsOpen[index] = value
            setIsOpen(nextIsOpen)
          },
        })
      )}
    </div>
  )
}

export default Accordion
